import styled from "styled-components";
import media from "@pagepro-monorepo/ui/lib/theme/config/media";

export const ListItem = styled.li`
  padding: 3rem 0;
  border-top: 1px solid ${({ theme }) => theme.colors.secondaryDecor};

  &:first-of-type {
    border-top: 0;
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  @media ${media.tablet} {
    padding: 6.5rem 0;
  }
`;
